import React from 'react'
import { Box, Stepper, Step, StepLabel } from '@mui/material'

type Props = {
  steps: string[]
  currentStep: number
  onStepClick?: (stepIndex: number) => void
}

const ProgressStepper: React.FC<Props> = ({
  steps,
  currentStep,
  onStepClick,
}) => {
  return (
    <Box sx={{ mb: 6 }}>
      <Stepper activeStep={currentStep} alternativeLabel>
        {steps.map((label, index) => (
          <Step key={label}>
            <StepLabel
              onClick={() => {
                if (onStepClick && index < currentStep) {
                  onStepClick(index)
                }
              }}
              sx={{
                '& .MuiStepLabel-label': {
                  fontSize: {
                    xs: '0.75rem',
                    sm: '0.875rem',
                  },
                  fontWeight: index === currentStep ? 600 : 400,
                },
                '& .MuiStepIcon-root': {
                  color: index <= currentStep ? '#7A6FA1' : 'grey.300',
                  '&.Mui-active': {
                    color: '#7A6FA1',
                  },
                  '&.Mui-completed': {
                    color: '#7A6FA1',
                  },
                },
                cursor: index < currentStep ? 'pointer' : 'default',
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  )
}

export default ProgressStepper

